import {Injectable} from '@angular/core';
import {MatomoInjector, MatomoTracker} from 'ngx-matomo';
import { ConfigService } from './configService/config.service';

@Injectable({
  providedIn: 'root',
})
export class MatomoHelperService {
  private matomoEnabled: boolean = false;

  constructor(
    private configService: ConfigService,
    private matomoInjector: MatomoInjector,
    private matomoTracker: MatomoTracker,
  ) {}

  public initCookies() {
    this.matomoEnabled = this.configService.getConfig('matomoEnabled');
    if (this.matomoEnabled) {
      const matomoUrl : string = this.configService.getConfig('matomoUrl');
      const matomoSiteId : string = this.configService.getConfig('matomoSiteId');
      if (! matomoUrl || ! matomoSiteId) {
        console.log("To use matomo, both 'matomoUrl' and 'matomoSiteId' must be configured!")
      } else {
        this.matomoInjector.init(this.configService.getConfig('matomoUrl'), this.configService.getConfig('matomoSiteId'));
      }
    }
  }

  public hasCookies() {
    return this.matomoEnabled && this.matomoTracker.hasCookies();
  }

  public async disableCookies() {
    const hasCookies = await this.hasCookies();

    if (hasCookies) {
      this.matomoTracker.disableCookies();
      this.matomoTracker.deleteCookies();
    }
  }

  public logNavigation(sourceComponent: string, toUrl: string, additionalData?: any) {
    this.logOtherAction(sourceComponent, 'navigation', toUrl, additionalData);
  }

  public logStartForm(sourceComponent: string, additionalData?: any) {
    this.logOtherAction(sourceComponent, 'form', 'start', additionalData);
  }

  public logCancelForm(sourceComponent: string, additionalData?: any) {
    this.logOtherAction(sourceComponent, 'form', 'cancel', additionalData);
  }

  public logSubmitForm(sourceComponent: string, additionalData?: any) {
    this.logOtherAction(sourceComponent, 'form', 'submit', additionalData);
  }

  public logSuccessForm(sourceComponent: string, additionalData?: any) {
    this.logOtherAction(sourceComponent, 'form', 'success', additionalData);
  }

  public logFailForm(sourceComponent: string, additionalData?: any) {
    this.logOtherAction(sourceComponent, 'form', 'fail', additionalData);
  }

  public logDialogShown(sourceComponent: string, additionalData?: any) {
    this.logOtherAction(sourceComponent, 'dialog', 'shown', additionalData);
  }

  public async logOtherAction(sourceComponent: string, action: string, name: string, additionalData?: any) {
    const hasCookies = await this.hasCookies();

    if (hasCookies) {
      this.matomoTracker.trackEvent(sourceComponent, action, name, additionalData);
    }
  }

  setUp(userId: string, title: string, releaseDate: string) {
    if (this.matomoEnabled) {
      this.matomoTracker.setUserId(userId);
      this.matomoTracker.setDocumentTitle(title);
      this.matomoTracker.setCampaignNameKey(releaseDate);
    }
  }
}
